const e = (r) => {
  const t = Number(r) || 0;
  return t % 1 !== 0 ? t.toFixed(2) : t.toString();
};
export {
  e as formatPrice
};
